import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  OPEN: "Opened",
  NAVIGATED: COMMON_EVENT_NAMES.NAVIGATED
};

export const LABELS = { PROMOS: "Promos" };
